import { render, staticRenderFns } from "./HidePanelRegister.vue?vue&type=template&id=00b26e48&"
import script from "./HidePanelRegister.vue?vue&type=script&lang=js&"
export * from "./HidePanelRegister.vue?vue&type=script&lang=js&"
import style0 from "./HidePanelRegister.vue?vue&type=style&index=0&id=00b26e48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports